import { Download } from 'lucide-react';
import { useState } from 'react';

export default function ResumePage() {
  const [showPdf, setShowPdf] = useState(false);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center p-8 bg-gradient-to-br from-blue-50 to-indigo-100">
      <div className="max-w-4xl w-full text-center mb-8">
        <h1 className="text-5xl font-bold text-gray-800 mb-4">My Resume</h1>
        <button
          onClick={() => setShowPdf(!showPdf)}
          className="bg-blue-600 hover:bg-blue-700 text-white font-semibold py-3 px-6 rounded-lg transition-colors duration-200 flex items-center gap-2 mx-auto"
        >
          {showPdf ? 'Hide Resume' : 'View Resume'}
          <Download className="w-5 h-5" />
        </button>
      </div>

      {showPdf && (
        <div className="w-full max-w-4xl h-[80vh] bg-white rounded-lg shadow-xl overflow-hidden">
          <iframe 
            src="/documents/resume.pdf" 
            className="w-full h-full"
            title="My Resume" 
          />
        </div>
      )}
    </div>
  );
}